import CustomForm from "../CustomForm";
import m from "mithril";
import {RadioItem} from "../../model/items/radio";
import ICustomFormSettings from "../ICustomFormSettings";
import HubCell from "../shared/components/FormCell/HubCell";
import {loadJsonFromString} from "../shared/helpers";
import {CellItem} from "../../model/items/cellItem";

/**
 * Hub
 *
 * Transform form with single radio list to hub
 */
export default abstract class Hub extends CustomForm {

    private readonly hubCells: HubCell[] = [];

    protected autoSubmitNextForm = false;
    protected isSubmitting = false;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        loadJsonFromString(settings.form.aux1?.toLowerCase(), settings.form.questionary, (data) => {
            this.autoSubmitNextForm = Boolean(data?.['autosubmitnextform']);
        });

        for (let cell of this.settings.form.grid.cells) {
            for (const cellItem of cell.cellItems) {
                if (cellItem instanceof RadioItem) {
                    this.hubCells[cell.row] = new HubCell(
                        cell,
                        (cellItem: CellItem, value: any) => {
                            if (!this.isSubmitting) {
                                this.onSetValue(cellItem, value);
                                if (this.autoSubmitNextForm && cellItem instanceof RadioItem && this.settings.form.validate()) {
                                    this.isSubmitting = true;
                                    setTimeout(() => this.settings.nextForm(), 350);
                                }
                            }
                        },
                    );
                    break;
                }
            }
        }

    }

    public rewriteFormControls() {
        return true;
    }

    checkRequirements(): boolean {
        const form = this.settings.form;

        for (let cell of form.grid.cells) {
            if (!(cell.cellItems[0] instanceof RadioItem)) {
                console.log('customForm-Hub-default: form includes more than radio, expect only radio');
                return false;
            }
        }

        return true;
    }

    public view() {

        return this.viewLayout(
            m("form", {}, this.hubCells.map(cell => m(cell)))
        );

    };
}
